import IComponent from "components/commons/IComponent";
import MiniPanel from "components/commons/MiniPanel";
import SwitchButton from "components/commons/SwitchButton";
import geometryTools from "utils/geometryTools";
import "./LayerSetting.scoped.css";
import OpacitySlider from "./OpacitySlider";

const LAYER_TYPE_OPACITY_SUPPORT = {
  "building-scene": 1,
  // "point-cloud": 1,
  scene: 1,
  feature: 1,
};
class Layer3DList extends IComponent {
  constructor(props) {
    super(props);
  }
  componentDidMount() {}
  componentWillUnmount() {}
  createLayerSwitch(mapList, firstLayer) {
    let vm = this;
    let showActiveItem = this.props.showActiveItem;
    let recursiveFindVisible = (l) =>
      l.some((i) =>
        i.type == "group" ? recursiveFindVisible(i.layers) : i.visible
      );
    if (showActiveItem && !recursiveFindVisible(mapList.layers)) return null;
    let switches = mapList.layers.map((c, idx) => {
      if (firstLayer)
        return (
          <MiniPanel
            titleText={c.title}
            titleClass="SubPanelContent"
            key={`${c}-${idx}`}
          >
            {this.createLayerSwitch(c)}
          </MiniPanel>
        );
      else
        return (
          <div
            key={`Layer3D-${c.title}-${idx}`}
            className="ListItemBottomLine SubPanelContent"
            style={
              showActiveItem &&
              (!c.visible ||
                (c.type === "group" && !recursiveFindVisible(c.layers)))
                ? { display: "none" }
                : {}
            }
          >
            <SwitchButton
              label={
                <span style={c.type == "group" ? { fontWeight: "bold" } : {}}>
                  {c.title}
                </span>
              }
              placeAtRight={true}
              checked={c.visible}
              onClick={() => {
                c.visible = !c.visible;
                vm.props.showDialog({ isOpen: false });
              }}
              needMidICON={c.type !== "group" && c.visible}
              midICONClassName={"icn_zoomtolayer"}
              disableLabelClick={true}
              midICONOnClick={async () => {
                //console.log("zoom to layer by mid icon", c2, c);
                if (c && c.fullExtent && c.type !== "voxel") {
                  let newCam = vm.props.mapView.camera.clone();
                  newCam.tilt = 45;
                  await this.props.mapView.goTo(newCam, { animate: false });
                  await this.props.mapView.goTo(c.fullExtent, {
                    animate: false,
                  });
                } else if (c && c.fullExtent && c.type === "voxel") {
                  // await geometryTools.projection.load();
                  let activeExtent = c.fullExtent;
                  activeExtent.spatialReference = new geometryTools.SpatialReference(
                    {
                      wkid: 102140,
                      latestWkid: 2326,
                    }
                  );
                  activeExtent.zmin = -30;
                  let extentBuffer = 1000;
                  Object.keys(activeExtent).forEach((key) => {
                    if (["xmax", "ymax"].includes(key)) {
                      activeExtent[key] += extentBuffer;
                    }
                    if (["xmin", "ymin"].includes(key)) {
                      activeExtent[key] -= extentBuffer;
                    }
                  });
                  vm.props.mapView.goTo(activeExtent).catch((err) => {
                    console.warn(err);
                  });
                }
              }}
            />
            {c.type == "group" && this.createLayerSwitch(c)}
            {c.type in LAYER_TYPE_OPACITY_SUPPORT && c.visible && (
              <OpacitySlider layer={c} />
            )}
          </div>
        );
    });
    return switches;
  }
  render() {
    let vm = this;
    let layerList = this.$config[`mapList${this.props.isSecondMap ? "2" : ""}`];
    if (!layerList) return <div />;
    let mapView = this.props.mapView;
    if (!mapView) return;
    let layerBtn = null;
    let layer3D = mapView.map.layers.find((i) => i.title === "3D Layers");
    if (!layer3D) return;
    return <div>{this.createLayerSwitch(layer3D, true)}</div>;
  }
}

export default Layer3DList;
